import React from 'react';

import ExternalSlot from '@solvhealth/types/interfaces/ProviderGroup/ExternalSlot';
import { SlotShape } from '../../../../../shapes/Slot';

import DateTime, { HOUR_MINUTE_PERIOD } from '../../../../DateTime';

import TimeSlot from './TimeSlot';

type Props = {
  slot?: SlotShape | ExternalSlot;
  timeZone?: string;
  darkTheme?: boolean;
  isSelected?: boolean;
  className?: string;
  onSelect?: (...args: any[]) => any;
  isSrp?: boolean;
  isExternalSlot?: boolean;
  isCTA?: boolean;
  // shows the modality, e.g. "IN OFFICE" or "VIDEO" as a subtitle
  showModalitySubtitle?: boolean;
};

const Slot = (props: Props) => {
  const {
    slot,
    timeZone,
    darkTheme,
    isSelected,
    className,
    onSelect,
    isSrp,
    isExternalSlot,
    isCTA,
    showModalitySubtitle,
  } = props;
  const { availability, isReservationsDisabled, modality } = (slot as SlotShape) || {};

  // snake vs. camel shenanigans *eye roll*
  const { appointmentDate } = slot as SlotShape;
  const { appointment_date } = slot as ExternalSlot;

  const isAvailable = isExternalSlot ? true : availability > 0 && !isReservationsDisabled;
  const formattedTime = DateTime.format(
    appointmentDate || appointment_date,
    timeZone
  )(HOUR_MINUTE_PERIOD);

  return (
    <TimeSlot
      className={className}
      darkTheme={darkTheme}
      isAvailable={isAvailable}
      isCTA={isCTA}
      isSelected={isSelected}
      isSrp={isSrp}
      modality={modality}
      onSelect={() => onSelect && onSelect(slot)}
      showModalitySubtitle={showModalitySubtitle}
      time={formattedTime}
    />
  );
};

export default Slot;
